import { header } from 'api/Auth/auth';
import axios, { AxiosError } from 'axios';
import { apiPaths } from 'constants/path';
import { tokenHeader } from 'functions/apiFunctions';
import { CommonErrorApiTypes } from 'models/Common/commonApiTypes';
import { DiagnosisUpdateReqeustType, GetResultDiagnosisApiResponse, IDDiagnosisApi } from 'models/DCK/DCKApiTypes';
import { GetAssessmentAiResultResponse, GetDiagnosisListResponse, GetDeviceKeyCountResponse } from 'models/MindUp/MindUpApiTypes';
import { AiChatUpdateRqData, AssessmentRequest, ChangeDiagnosisStatusRqData, CounselDateTimeRqData, VoucherAddDiagnosisRqData } from 'models/MindUp/MindUpTypes';
import { SungnamDiagnosisResponse } from 'models/MindUp/SungnamDiagnosisResponse';

class MindUpDiagnoisisApi {
    async addDiagnosis(rqData: VoucherAddDiagnosisRqData, token: string): Promise<IDDiagnosisApi> {
        try {
            const response = await axios.post(apiPaths.addDiagnosis, rqData, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async changeDiagnosisStatus(rqData: ChangeDiagnosisStatusRqData, token: string): Promise<IDDiagnosisApi> {
        try {
            const response = await axios.put(apiPaths.changeDiagnosisStatus, rqData, {
                headers: tokenHeader(token),
            });

            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async updateDiagnosisInfo(rqData: DiagnosisUpdateReqeustType, token: string): Promise<IDDiagnosisApi> {
        try {
            const response = await axios.put(apiPaths.updateDiagnosisInfo, rqData, {
                headers: tokenHeader(token),
            });

            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async updateCounselDateTime(rqData: CounselDateTimeRqData, token: string): Promise<IDDiagnosisApi> {
        try {
            const response = await axios.put(apiPaths.updateCounselDateTime, rqData, {
                headers: tokenHeader(token),
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async updateAssessmentAiResult(rqData: AssessmentRequest, token: string): Promise<GetAssessmentAiResultResponse> {
        try {
            const response = await axios.put(apiPaths.updateAssessmentAiResult, rqData, {
                headers: tokenHeader(token),
            });

            return response.data;
        } catch (error) {
            throw error;
        }
    }
    async updateAiChatMessage(rqData: AiChatUpdateRqData, token: string): Promise<GetAssessmentAiResultResponse> {
        try {
            const response = await axios.put(apiPaths.updateAiChatMessage, rqData, {
                headers: tokenHeader(token),
            });

            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getDiagnosisByDeviceKey(deviceKey: string): Promise<SungnamDiagnosisResponse> {
        try {
            const response = await axios.get(apiPaths.getDiagnosisByDeviceKey + deviceKey, {
                headers: header,
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getListByDeviceKey(encryptedToken: string): Promise<GetDiagnosisListResponse> {
        try {
            const response = await axios.get(apiPaths.getListByDeviceKey + encryptedToken, {
                headers: header,
            });
            return response.data;
        } catch (error) {
            if ((error as any).response) {
                throw (error as any).response.data;
            }
            throw error;
        }
    }

    async getDeviceKeyCount(): Promise<GetDeviceKeyCountResponse> {
        try {
            const response = await axios.get(apiPaths.getDeviceKeyCount, {
                headers: header,
            });
            console.log('getDeviceKeyCount', response.data);
            return response.data.data;
        } catch (error) {
            if ((error as any).response) {
                throw (error as any).response.data;
            }
            throw error;
        }
    }
}
export const mindUpDiagnosisApi = new MindUpDiagnoisisApi();
